import styled from '@emotion/styled';
import { typographyFontSizeCfg } from 'ds/components/typography/types';
import { H3, Text } from 'ds/components/typography';
import { Button } from 'ds/components/button';
import { BulletinStatusType } from 'utils/entities';

export const ChangeStatusPopupRoot = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    padding: ${theme.spacing(2)} 0 ${theme.spacing(3.5)} 0;
    color: ${theme.colors.neutrals.grey1};
    gap: ${theme.spacing(0.5)};
    text-align: center;
    width: 320px;
    max-width: 100%;
    margin: 0 auto;
  `}
`;

export const MakePromotedPopupRoot = styled(ChangeStatusPopupRoot)`
  padding-bottom: ${({ theme }) => theme.spacing(1.25)};
`;

export const MakePromotedPopupHeaderWrapper = styled(H3)`
  ${({ theme }) => `
    margin-top: ${theme.spacing(3)};
    margin-bottom: ${theme.spacing(0.5)};
  `}
`;

export const ConfirmButtonWrapper = styled(Button)`
  margin-top: ${({ theme }) => theme.spacing(4)};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-top: ${theme.spacing(5)};
  `}
`;

export const CancelWrapper = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey2};
  font-weight: 500;
  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.neutrals.grey1};
  }
`;

export const ExclusivityExpiredLabel = styled.div`
  color: #498A90;
`;

export const ExclusivityExpiredText = styled.div`
  line-height: 12px;
  font-size: ${typographyFontSizeCfg.textLabel.small}px;
`;

export const ListingImage = styled.img`
  border-radius: ${({ theme }) => theme.borderRadius.micro};
  object-fit: cover;
`;

export const DeleteListingPopupRoot = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    padding: ${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(1.5)} ${theme.spacing(2)};
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding-left: 0;
    padding-right: 0;
  `}
`;

export const DeleteListingPopupSubheader = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  width: 306px;
  max-width: 100%;
  text-align: center;
`;

export const RedButton = styled(Button)`
  width: 220px;
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  border: ${({ theme }) => theme.colors.alert.red};
  background: ${({ theme }) => theme.colors.alert.red};

  &:hover {
    border: #B40116;
    background: #B40116;
  }
`;

export const BellErrorIconWrapper =  styled.div`
  display: flex;
  width: 80px;
  height: 80px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  background: ${({ theme }) => theme.colors.alert.redBackground};
`;

export const StatusCircle = styled.div<{ status: BulletinStatusType }>`
  width: 8px;
  height: 8px;
  border-radius: ${({ theme }) => theme.borderRadius.round};

  background: ${({ theme, status }) =>
    status === BulletinStatusType.Displayed ? theme.colors.alert.green : theme.colors.alert.red};
`;

export const SuccessToastRoot = styled.div<{ isIOS: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: 0 ${({ theme }) => theme.spacing(2)};
  background: #e5f2e0;
  color: #390;
  z-index: 10001;

  ${({ theme, isIOS }) => theme.media.showAt({ to: 2 })`
    bottom: ${isIOS ? theme.spacing(6) : theme.spacing(3)};
    left: 12px;
    right: 12px;
    border-radius: ${theme.borderRadius.tiny};
  `}

  svg {
    path {
      stroke: #390;
      stroke-width: 1px;
    }
  }

  @keyframes fadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
`;

export const CancelButton = styled(Text)`
  margin-top: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.colors.neutrals.grey2};
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s;
  &:hover {
    color: ${({ theme }) => theme.colors.neutrals.grey1};
  }
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-top: ${theme.spacing(3)};
  `}
`;
